/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PortalConfig,
} from '../models';
import {
    PortalConfigFromJSON,
    PortalConfigToJSON,
} from '../models';

/**
 * 
 */
export class PortalConfigApi extends runtime.BaseAPI {

    /**
     * Gets the client configuration for the portal
     * Get Portal Config
     */
    async getPortalConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/portal-config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalConfigFromJSON(jsonValue));
    }

    /**
     * Gets the client configuration for the portal
     * Get Portal Config
     */
    async getPortalConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalConfig> {
        const response = await this.getPortalConfigRaw(initOverrides);
        return await response.value();
    }

}
